import React from 'react';
import { Container } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

const DashboardPage: React.FC = () => {
  const { role, isAuthenticated } = useAuth();

  return (
    <Container>
      <h1>Dashboard</h1>
      <div>
        <p>Authentication Status: {isAuthenticated ? 'Authenticated' : 'Not Authenticated'}</p>
        <p>User Role: {role || 'No role assigned'}</p>
      </div>
    </Container>
  );
};

export default DashboardPage; 